import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Get preload priority from route data
    const preloadPriority = route.data?.['preload'] || false;
    
    if (preloadPriority === 'high') {
      // Load immediately for high priority routes
      return load();
    } else if (preloadPriority === 'medium') {
      // Load after 2 seconds for medium priority routes
      return timer(2000).pipe(mergeMap(() => load()));
    } else if (preloadPriority === 'low') {
      // Load after 5 seconds for low priority routes
      return timer(5000).pipe(mergeMap(() => load()));
    }
    
    // Don't preload by default
    return of(null);
  }
}
